import Vue from "vue";
import reactiveCache from "./reactive-cache";
import { Item } from "./item";

const config = {
  1: [],
  2: [],
  3: [],
}

const settings = new Vue({
  data: {
    config: config
  },
  computed: {
    // 1st group - settings that users should have access to
    defaultFolded: addSetting(1, "defaultFolded", false, "domyślnie zwijaj podzadania"),
    showSidePanel: addSetting(1, "showSidePanel", true, "zawsze pokazuj boczny panel"),
    openInSideView: addSetting(1, "openInSideView", true, "otwieraj zadania w bocznym panelu"),
    resetSideView: addSetting(1, "resetSideView", true, "resetuj boczny panel przy zmianie widoku"),

    // 2nd group - features that are not quite ready
    hideDone: addSetting(2, "hideDone", false, "hide done tasks"),
    allowArchiving: addSetting(2, "allowArchiving", false, "allow archiving items"),
    hideArchived: addSetting(2, "hideArchived", false, "hide archived items"),
    nestedLists: addSetting(2, "nestedLists", false, "allow creating nested lists"),
    labelsEnabled: addSetting(2, "labelsEnabled", false, "enable labels"),
    boardsEnabled: addSetting(2, "boardsEnabled", false, "enable custom views"),
    showOrphans: addSetting(2, "showOrphans", false, "show items without a list"),
    altViews: addSetting(2, "altViews", false, "enable alternative views"),
    oldCalendar: addSetting(2, "oldCalendar", false, "old calendar view"),
    dumpTextEnabled: addSetting(2, "dumpTextEnabled", false, "allow downloading item as text file"),
    homeView: addSetting(2, "homeView", "/welcome", "Home view:"),
    sideView: addSetting(2, "sideView", "day:current", "Default side view (use day:current for today):"),

    // 3rd group - tweaking app behaviour
    notepadEnabled: addSetting(3, "notepadEnabled", true, "enable notepad"),
    periodsEnabled: addSetting(3, "periodsEnabled", true, "enable custom time periods"),
    editAction: addSetting(3, "editAction", false, "show edit action in menu"),
    openAction: addSetting(3, "openAction", false, "show open action in menu"),
    insertAction: addSetting(3, "insertAction", false, "show insert action in menu"),
    copyIdAction: addSetting(3, "copyIdAction", false, "show copy ID action in menu"),
    RMBselects: addSetting(3, "RMBselects", false, "right click selects items"),
    implicitInsert: addSetting(3, "implicitInsert", false, "implicit insert mode with selection"),
    periodsInCal: addSetting(3, "periodsInCal", true, "show periods in calendar view"),
    leafCursor: addSetting(3, "leafCursor", "edit", "Special cursor to use when the default action is edit. Choices: none, edit, edit2:"),
  },
  methods: {},
});

export default settings;

function addSetting(group, key, defaultValue, description) {
  config[group].push({
    key,
    description,
    type: defaultValue === true || defaultValue === false ? "bool" : "text",
  });
  return {
    get() {
      const doc = reactiveCache.get(".settings/" + key);
      return doc?.value ?? defaultValue;
    },
    set(value) {
      let doc = reactiveCache.get(".settings/" + key);
      if (!doc) {
        doc = new Item(
          { _id: ".settings/" + key },
          reactiveCache,
          reactiveCache.defaultDB,
        );
      }
      return doc.clone({ value }).save();
    },
  };
}
